export default __webpack_public_path__ + "static/media/sd-event1.7d0e8e3e.webp";